import Vue from 'vue'
import Channels from '@/store/modules/channels'

Vue.filter('channelIcon', function(channelType) {
  return Channels.iconName(channelType)
})

export default {}
